import { render } from "./ConfirmSalesNote.vue?vue&type=template&id=ddd811ce&scoped=true&ts=true"
import script from "./ConfirmSalesNote.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmSalesNote.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmSalesNote.vue?vue&type=style&index=0&id=ddd811ce&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3807180263/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddd811ce"],['__file',"src/components/scan/salesnote/kdp/ConfirmSalesNote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddd811ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddd811ce', __exports__)) {
    console.log('reload')
    api.reload('ddd811ce', __exports__)
  }
  
  module.hot.accept("./ConfirmSalesNote.vue?vue&type=template&id=ddd811ce&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('ddd811ce', render)
  })

}


export default __exports__